import { Component, Input, OnInit, ElementRef, Renderer2, ViewChild, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { SwiperOptions } from 'swiper';
import { CmsService } from '../../services/cms.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { takeUntil } from 'rxjs/operators';
import { BrandContainerIds } from '../../config/feature.config';

@Component({
  selector: 'ui-grid',
  templateUrl: './ui-grid.component.html',
  styleUrls: ['./ui-grid.component.scss']
})
export class UiGridComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() component;
  @Input() parent;

  public children;
  @ViewChild('childrenWrapper') childrenWrapper: ElementRef;

  private _destroy$ = new Subject();
  public newsContainerSelector = 'ui-grid--news-container';
  public destinationContainerIds = [69];
  public brandContainerIds = environment.production ? BrandContainerIds.prod : BrandContainerIds.pre;
  public bannerUtiliContainerId = 136;
  public allNews: any = null;
  public brand: any;
  public swiperNewsConfig: SwiperOptions;
  private interval;

  public isBrandContainer = false;


  constructor(
    private _renderer: Renderer2,
    private _cmsService: CmsService,
    private _changeRef: ChangeDetectorRef,
    private _router: Router
  ) { }

  ngOnInit(): void {
    if (this.component.componentConfig.selector == this.newsContainerSelector) {
      this._cmsService.allNews$.pipe(takeUntil(this._destroy$)).subscribe(news => {
        if (news) {
          const formattedNews = this.formatNews(news);
          this.allNews = formattedNews.filter((x) => !x.attributes.includes('heyconad') && !x.attributes.includes('heyconad_inst'));
        }
      });
    }

    this._cmsService.brandConfig$.pipe(takeUntil(this._destroy$)).subscribe(brand => {
      if (brand) this.brand = brand;
    });

    this.isBrandContainer = this.brandContainerIds.includes(this.component.componentConfig.id);
  }

  ngAfterViewInit(): void {
    if (this.childrenWrapper && this.childrenWrapper.nativeElement.children.length > 0) {
      this.children = this.childrenWrapper.nativeElement.children;
      const gridClass = this.component.componentConfig.styles.find(x => x.cssClass.includes("cs--grid"));
      if (gridClass != undefined) {
        this._renderer.addClass(this.childrenWrapper.nativeElement, "cs--grid");
        this._renderer.addClass(this.childrenWrapper.nativeElement, gridClass.cssClass);
        for (let child in this.children) {
          if (this.children[child] != undefined && typeof this.children[child] == 'object') {
            this._renderer.addClass(this.children[child], `child-${Number(child) + 1}`);
            this._renderer.addClass(this.children[child], `child`);
          }
        }
      }
    }
    if (this.allNews) this.createSwiperConfig();
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete();
    clearInterval(this.interval);
  }

  private createSwiperConfig(): void {
    const swiperPreviousEl =  document.getElementById('previousNews');
    const swiperNextEl = document.getElementById('nextNews');
    this.swiperNewsConfig = {
      breakpoints: {
        320: { slidesPerView: 1 },
        600: { slidesPerView: 2 },
        1200: { slidesPerView: 3 }
      },
      spaceBetween: 10,
      simulateTouch: true,
      loop: true,
      centeredSlides: false,
      navigation: {
        nextEl: swiperNextEl,
        prevEl: swiperPreviousEl
      }
    };
    this._changeRef.detectChanges();

    //Ogni 5 secondi scorrerà il banner
    this.interval = setInterval(() => {
      swiperNextEl.click();
    }, 5000)
  }

  private formatNews(news) {
    return news.map(news => {
      news['href'] = `${news.type.basePath}${news.path}`;
      return news;
    })
  }

  public goToNews(): void {
    this._router.navigate(['news']);
  }
}
